import { setCookie, doesCookieExist } from '../../../../core/util/cookies';

const getDismissedTileCookieName = (tileId: any, userProfile: any) =>
  `${tileId} - ${userProfile.id}`;

export const handleDismissTileForUserProfile = (tileId: any, userProfile: any) =>
  setCookie(getDismissedTileCookieName(tileId, userProfile));

export const hasTileBeenDismissedForUserProfile = (tileId: any, userProfile: any) =>
  doesCookieExist(getDismissedTileCookieName(tileId, userProfile));
